import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'jhi-custom-pol-pod',
  templateUrl: './custom-pol-pod.component.html',
  styleUrls: ['./custom-pol-pod.component.scss']
})
export class CustomPolPodComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
